import { render, staticRenderFns } from "./grossing-touch-people-sidepanel.vue?vue&type=template&id=62b2ab81&"
import script from "./grossing-touch-people-sidepanel.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-people-sidepanel.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports